<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="sidebar"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img
      :src="sidebarImage"
      height="100%"
    >
      <v-list
        class="fill-height"
        prop="v-list"
        column
      >
        <v-list-tile avatar>
          <v-list-tile-avatar
            color="white"
          >
            <v-img
              :src="logo"
              contain
            />
          </v-list-tile-avatar>
          <v-list-tile-title class="title">
            Einkaufskreis CMS
          </v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <v-list-tile
          v-for="(item, i) in items"
          :key="i"
          :to="{ name: item.route }"
          avatar
          class="v-list-item"
          active-class="primary"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="item.text"
          />
        </v-list-tile>
      </v-list>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Navigation',
  data: () => ({
    logo: './img/logo_small.png',
    sidebarImage: './img/sidebar.jpg',
    items: [
      {
        icon: 'dashboard',
        text: 'Dashboard',
        route: 'Dashboard',
        admin: false,
      },
      {
        icon: 'group',
        text: 'Mitglieder',
        route: 'Members',
        admin: false,
      },
      {
        icon: 'group_work',
        text: 'Branchen',
        route: 'Branches',
        admin: false,
      },
      {
        icon: 'event',
        text: 'Veranstaltungen',
        route: 'Events',
        admin: false,
      },
      {
        icon: 'attach_file',
        text: 'Dateiverwaltung',
        route: 'Files',
        admin: false,
      },
      // { icon: 'settings', text: 'Settings', route: 'Settings', admin: false },
    ],
    responsive: false,
  }),
  computed: {
    ...mapGetters({
      isAdmin: 'auth/isAdmin',
    }),
    sidebar: {
      get() {
        return this.$store.getters['ui/sidebar'];
      },
      set(value) {
        this.$store.dispatch('ui/setSidebar', value);
      },
    },
  },
};
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
</style>
